// A possession starts at actual disc contact, not the larger kick reach.
// Rearm only after a sustained gap so Continue cannot stop on the same touch.
export function createPossessionTracker() {
  let latched = false;
  let outsideTicks = 0;
  return {
    reset(skipCurrent = false) { latched = skipCurrent; outsideTicks = 0; },
    update(player, ball, active) {
      if (!active || !player || !ball) { latched = false; outsideTicks = 0; return false; }
      const distance = Math.hypot(player.position.x - ball.position.x, player.position.y - ball.position.y);
      const touching = distance <= player.radius + ball.radius + 8;
      // Use the same tolerance for contact and for the sustained gap that
      // rearms the tracker. A smaller gap threshold caused ordinary contact
      // frames to rearm every few ticks and prevented Live Analysis from
      // accumulating contact age.
      if (distance > player.radius + ball.radius + 8) {
        if (++outsideTicks >= 6) latched = false;
      } else outsideTicks = 0;
      if (!touching || latched) return false;
      latched = true;
      return true;
    }
  };
}
